import K, { useLayoutEffect as ne, useEffect as I, useState as x, useRef as R, useMemo as z, useCallback as b, useDebugValue as k } from "react";
import U from "mitt";
const P = typeof window < "u", F = P ? ne : I;
function re(e) {
  return !!(e && e[" fns-wire"]);
}
function oe() {
  return { " fns-wire": !0 };
}
function B(e) {
  const n = U(), t = re(e) ? e : null, r = {
    get: function(g, v) {
      return (...p) => {
        t ? t.fns[v](...p) : n.emit(v, { type: v, args: p });
      };
    }
  }, u = new Proxy({}, r), l = {
    fn: (g, v) => {
      if (t)
        return t.fn(g, v);
      {
        const p = (a) => {
          v(...a.args);
        };
        return n.on(g, p), () => {
          n.off(g, p);
        };
      }
    },
    fns: u
  }, S = () => () => {
  };
  return [{ ...l, ...oe() }, S];
}
const $ = (e) => B(e || {});
function Y(e) {
  const [[n, t], r] = x(() => $(e)), u = R(e);
  return F(() => {
    u.current !== e && (u.current = e, r($(e)));
  }, [e]), I(() => t(), [t]), n;
}
function ue(e) {
  return typeof e == "function";
}
const W = (e) => e !== void 0;
function J(e) {
  let n, t;
  return function(...r) {
    return n !== void 0 && n.length === r.length && n.every((u, o) => u === r[o]) || (n = r, t = e(...r)), t;
  };
}
let se = 0;
function Q(e = "") {
  const n = se++;
  return `${e}${n}`;
}
function me(e) {
  return (e == null ? void 0 : e._getId()) ?? void 0;
}
function ye(e) {
  return (e == null ? void 0 : e._getLinkIds()) ?? void 0;
}
function ce(e) {
  return !!(e && e[" state-wire"] && e[" state-wire"][0] && e[" state-wire"][1]);
}
function X() {
  return { " state-wire": [
    !0,
    !0
    /* write */
  ] };
}
function Z(e, n) {
  const t = "value";
  let r = n;
  const u = U(), o = ce(e) ? e : null, l = () => {
    const c = o ? o.getValue() : void 0;
    return c === void 0 ? r : c;
  }, S = (c) => {
    o ? o.setValue(c) : r !== c && (r = c, u.emit(t, r));
  }, g = (c) => (u.on(t, c), () => {
    u.off(t, c);
  }), v = () => {
    if (o) {
      const c = o.getValue();
      return W(c) ? r = c : W(r) && o.setValue(r), o.subscribe((V) => {
        r = V, u.emit(t, V);
      });
    }
    return () => {
    };
  }, p = {
    getValue: l,
    setValue: S,
    subscribe: g
  }, a = Q("w-"), f = () => a, _ = J(
    (c) => c ? [...c._getLinkIds(), f()] : [f()]
  ), y = () => _(o);
  return [
    { ...p, ...X(), _getId: f, _getLinkIds: y },
    v
  ];
}
const j = (e, n) => Z(
  e || {},
  W(n) ? ue(n) ? n() : n : void 0
);
function w(e, n) {
  const [[t, r], u] = x(() => j(e, n)), o = R(e);
  return !P && e && e.getValue() === void 0 && t.getValue() !== void 0 && console.error(
    "upLink value is undefined. uplink without value is not supported in server side rendering"
  ), F(() => {
    o.current !== e && (o.current = e, u(j(e, t.getValue())));
  }, [e, t]), I(() => r(), [r]), t;
}
function Oe(e, n) {
  const t = Y(e), r = w(e, n);
  return z(() => ({ ...t, ...r }), [t, r]);
}
function ae(e) {
  return typeof e == "function";
}
function ie(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var M = { exports: {} }, A = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var N;
function fe() {
  if (N)
    return A;
  N = 1;
  var e = K;
  function n(a, f) {
    return a === f && (a !== 0 || 1 / a === 1 / f) || a !== a && f !== f;
  }
  var t = typeof Object.is == "function" ? Object.is : n, r = e.useState, u = e.useEffect, o = e.useLayoutEffect, l = e.useDebugValue;
  function S(a, f) {
    var _ = f(), y = r({ inst: { value: _, getSnapshot: f } }), c = y[0].inst, V = y[1];
    return o(function() {
      c.value = _, c.getSnapshot = f, g(c) && V({ inst: c });
    }, [a, _, f]), u(function() {
      return g(c) && V({ inst: c }), a(function() {
        g(c) && V({ inst: c });
      });
    }, [a]), l(_), _;
  }
  function g(a) {
    var f = a.getSnapshot;
    a = a.value;
    try {
      var _ = f();
      return !t(a, _);
    } catch {
      return !0;
    }
  }
  function v(a, f) {
    return f();
  }
  var p = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? v : S;
  return A.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : p, A;
}
var C = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var q;
function le() {
  return q || (q = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = K, n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function t(d) {
      {
        for (var i = arguments.length, m = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++)
          m[s - 1] = arguments[s];
        r("error", d, m);
      }
    }
    function r(d, i, m) {
      {
        var s = n.ReactDebugCurrentFrame, E = s.getStackAddendum();
        E !== "" && (i += "%s", m = m.concat([E]));
        var O = m.map(function(h) {
          return String(h);
        });
        O.unshift("Warning: " + i), Function.prototype.apply.call(console[d], console, O);
      }
    }
    function u(d, i) {
      return d === i && (d !== 0 || 1 / d === 1 / i) || d !== d && i !== i;
    }
    var o = typeof Object.is == "function" ? Object.is : u, l = e.useState, S = e.useEffect, g = e.useLayoutEffect, v = e.useDebugValue, p = !1, a = !1;
    function f(d, i, m) {
      p || e.startTransition !== void 0 && (p = !0, t("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var s = i();
      if (!a) {
        var E = i();
        o(s, E) || (t("The result of getSnapshot should be cached to avoid an infinite loop"), a = !0);
      }
      var O = l({
        inst: {
          value: s,
          getSnapshot: i
        }
      }), h = O[0].inst, D = O[1];
      return g(function() {
        h.value = s, h.getSnapshot = i, _(h) && D({
          inst: h
        });
      }, [d, s, i]), S(function() {
        _(h) && D({
          inst: h
        });
        var te = function() {
          _(h) && D({
            inst: h
          });
        };
        return d(te);
      }, [d]), v(s), s;
    }
    function _(d) {
      var i = d.getSnapshot, m = d.value;
      try {
        var s = i();
        return !o(m, s);
      } catch {
        return !0;
      }
    }
    function y(d, i, m) {
      return i();
    }
    var c = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", V = !c, T = V ? y : f, L = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : T;
    C.useSyncExternalStore = L, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), C;
}
process.env.NODE_ENV === "production" ? M.exports = fe() : M.exports = le();
var de = M.exports;
const Se = /* @__PURE__ */ ie(de), { useSyncExternalStore: ve } = Se;
function pe(e, n) {
  const t = b(
    (S) => (e == null ? void 0 : e.subscribe(() => S())) ?? (() => {
    }),
    [e]
  ), r = b(
    () => e == null ? void 0 : e.getValue(),
    [e]
  ), u = b(
    () => e == null ? void 0 : e.getValue(),
    [e]
  ), o = ve(
    t,
    r,
    u
  ), l = o === void 0 ? n : o;
  return k(l), l;
}
function Ie(e, n) {
  const t = w(e, n), r = pe(t);
  k(r);
  const u = b(
    (o) => {
      let l;
      if (ae(o)) {
        const S = t.getValue();
        W(S) && (l = o(S));
      } else
        l = o;
      W(l) && t.setValue(l);
    },
    [t]
  );
  return [r, u];
}
function H(e, n) {
  let t = n;
  const r = (o) => {
    t = o;
  };
  return [{ ...e, setValue: (o) => {
    const l = e.getValue(), S = t(o, l);
    W(S) && e.setValue(S);
  } }, r];
}
function We(e, n) {
  const [[t, r], u] = x(
    () => H(e, n)
  ), o = R(e);
  return F(() => {
    o.current !== e && (o.current = e, u(H(e, n)));
  }, [e, n]), r(n), t;
}
function Le(e, n, t) {
  I(() => e == null ? void 0 : e.fn(n, t), [e, n, t]);
}
function Re(e) {
  const [n] = Z({}, e), [t] = B({});
  return { ...t, ...n };
}
function _e() {
  return { " state-wire": [
    !0,
    !1
    /* write */
  ] };
}
const G = (e, n, t) => {
  e.forEach((r, u) => {
    r && !n.has(u) && (r(), e.set(u, null));
  }), n.forEach((r, u) => {
    const o = e.get(u) ?? u.subscribe(() => {
      t && t();
    });
    n.set(u, o);
  });
}, ge = (e) => {
  let n = !1;
  return e.forEach((t, r) => {
    t !== r.getValue() && (n = !0);
  }), n;
};
function ee(e) {
  const n = "value", t = { current: /* @__PURE__ */ new Map() }, r = { current: /* @__PURE__ */ new Map() };
  let { get: u, set: o } = e;
  const l = (s) => {
    t.current.set(s, null);
    const E = s.getValue();
    return r.current.set(s, E), E;
  }, S = (s) => s.getValue(), g = (s, E) => {
    s.setValue(E);
  };
  let v = u({ get: l });
  const p = U(), a = () => {
    const s = t.current, E = t.current = /* @__PURE__ */ new Map();
    r.current = /* @__PURE__ */ new Map();
    const O = v, h = u({ get: l });
    G(s, E, a), O !== h && (v = h, p.emit(n, h));
  }, f = () => {
    G(t.current, /* @__PURE__ */ new Map());
  }, _ = () => (ge(r.current) ? a() : G(/* @__PURE__ */ new Map(), t.current, a), (s) => {
    s ? (u = s.get, o = s.set, a()) : f();
  }), y = () => v, c = (s) => {
    o && o({ get: S, set: g }, s);
  }, V = (s) => (p.on(n, s), () => {
    p.off(n, s);
  }), T = Q("s-"), L = () => T, d = J((s) => [
    ...Array.from(s.keys()).map((E) => E._getLinkIds()),
    L()
  ]), i = () => d(t.current);
  return [o ? {
    getValue: y,
    subscribe: V,
    setValue: c,
    ...X(),
    _getId: L,
    _getLinkIds: i
  } : {
    getValue: y,
    subscribe: V,
    ..._e(),
    _getId: L,
    _getLinkIds: i
  }, _];
}
function be(e) {
  const [n, t] = B({}), [r, u] = ee(e);
  return t(), u(), { ...n, ...r };
}
function Ee(e, n = []) {
  const [[t, r]] = x(() => ee(e)), u = R(null);
  return I(() => {
    const o = u.current;
    o && o(e);
  }, n), I(() => {
    const o = r();
    return u.current = o, () => {
      o(), u.current = null;
    };
  }, [r]), t;
}
function xe(e, n) {
  const t = Y(null), r = Ee(e, n);
  return z(() => ({ ...t, ...r }), [t, r]);
}
function Te(e, n) {
  let t = R(e.getValue());
  I(() => {
    let r = e.getValue();
    return W(r) && r !== t.current && (n(r), t.current = r), e.subscribe(n);
  }, [e, n]);
}
export {
  be as createSelector,
  Re as createWire,
  ye as getLinkIds,
  me as getWireId,
  W as isDefined,
  Le as useFn,
  We as useInterceptor,
  xe as useSelector,
  Te as useSubscribe,
  Oe as useWire,
  Ie as useWireState,
  pe as useWireValue
};
